import React from 'react';
import './Services.css';

const Services = () => {
  return (
    <div className="services-page">
      {/* Hero Section */}
      <section className="services-hero">
        <div className="container">
          <h1>ನಮ್ಮ ಸೇವೆಗಳು</h1>
          <p>ರೈತರು ಮತ್ತು ವ್ಯಾಪಾರಿಗಳಿಗೆ ಸಮಗ್ರ ಕೃಷಿ ವ್ಯಾಪಾರ ಪರಿಹಾರಗಳು</p>
        </div>
      </section>

      {/* How to Sell Your Dal Section */}
      <section className="process-section">
        <div className="container">
          <h2>ಬೇಳೆ ಮಾರುವ ವಿಧಾನ</h2>
          <div className="process-steps">
            <div className="process-card">
              <div className="step-number">1</div>
              <div className="step-icon">
                <i className="fas fa-phone"></i>
              </div>
              <div className="step-content">
                <h3>ನಮ್ಮನ್ನು ಸಂಪರ್ಕಿಸಿ</h3>
                <p>ನಿಮ್ಮ ಬೇಳೆ ಸ್ಟಾಕ್ ಬಗ್ಗೆ ನಮಗೆ ಕರೆ ಮಾಡಿ ಅಥವಾ ಸಂದೇಶ ಕಳುಹಿಸಿ</p>
              </div>
            </div>
            <div className="process-card">
              <div className="step-number">2</div>
              <div className="step-icon">
                <i className="fas fa-microscope"></i>
              </div>
              <div className="step-content">
                <h3>ಗುಣಮಟ್ಟ ಪರಿಶೀಲನೆ</h3>
                <p>ನಿಮ್ಮ ಬೇಳೆಯ ಗುಣಮಟ್ಟವನ್ನು ನಾವು ಪರಿಶೀಲಿಸುತ್ತೇವೆ</p>
              </div>
            </div>
            <div className="process-card">
              <div className="step-number">3</div>
              <div className="step-icon">
                <i className="fas fa-handshake"></i>
              </div>
              <div className="step-content">
                <h3>ಬೆಲೆ ಒಪ್ಪಂದ</h3>
                <p>ನಿಮ್ಮ ಬೇಳೆಗೆ ಉತ್ತಮ ಮಾರುಕಟ್ಟೆ ಬೆಲೆ ಪಡೆಯಿರಿ</p>
              </div>
            </div>
            <div className="process-card">
              <div className="step-number">4</div>
              <div className="step-icon">
                <i className="fas fa-rupee-sign"></i>
              </div>
              <div className="step-content">
                <h3>ತ್ವರಿತ ಪಾವತಿ</h3>
                <p>24 ಗಂಟೆಗಳೊಳಗೆ ಪಾವತಿ ಪಡೆಯಿರಿ</p>
              </div>
            </div>
          </div>
        </div>
      </section>

      {/* Additional Benefits Section */}
      <section className="benefits-section">
        <div className="container">
          <h2>ಹೆಚ್ಚುವರಿ ಪ್ರಯೋಜನಗಳು</h2>
          <div className="benefits-grid">
            <div className="benefit-card">
              <i className="fas fa-balance-scale"></i>
              <h3>ನ್ಯಾಯೋಚಿತ ಬೆಲೆ</h3>
              <p>ನಿಮ್ಮ ಬೇಳೆಗೆ ಉತ್ತಮ ಮಾರುಕಟ್ಟೆ ದರಗಳು</p>
            </div>
            <div className="benefit-card">
              <i className="fas fa-shield-alt"></i>
              <h3>ಗುಣಮಟ್ಟ ಪರೀಕ್ಷೆ</h3>
              <p>ವೃತ್ತಿಪರ ಗುಣಮಟ್ಟ ಮೌಲ್ಯಮಾಪನ</p>
            </div>
            <div className="benefit-card">
              <i className="fas fa-truck"></i>
              <h3>ಸಂಗ್ರಹ ಸೇವೆ</h3>
              <p>ನಿಮ್ಮ ಸ್ಥಳದಿಂದ ಉಚಿತ ಸಂಗ್ರಹ</p>
            </div>
            <div className="benefit-card">
              <i className="fas fa-headset"></i>
              <h3>24/7 ಬೆಂಬಲ</h3>
              <p>ನಿಮಗೆ ಸಹಾಯ ಮಾಡಲು ಯಾವಾಗಲೂ ಇಲ್ಲಿದ್ದೇವೆ</p>
            </div>
          </div>
        </div>
      </section>

      {/* Current Market Rates Section */}
      <section className="market-rates-section">
        <div className="container">
          <h2>ಪ್ರಸ್ತುತ ಮಾರುಕಟ್ಟೆ ದರಗಳು</h2>
          <div className="rate-cards-grid">
            <div className="rate-card toor-dal">
              <h3>ತೋಗರೆ (Toor)</h3>
              <p className="rate">ಮಾರುಕಟ್ಟೆ ದರ</p>
              <ul className="features-list">
                <li><i className="fas fa-check"></i> ಪ್ರೀಮಿಯಂ ಗುಣಮಟ್ಟ</li>
                <li><i className="fas fa-check"></i> ಕನಿಷ್ಠ 1 ಕ್ವಿಂಟಾಲ್</li>
                <li><i className="fas fa-check"></i> ಉಚಿತ ಗುಣಮಟ್ಟ ಪರೀಕ್ಷೆ</li>
              </ul>
              <button className="get-rate-btn">ಇಂದಿನ ದರ ಪಡೆಯಿರಿ</button>
            </div>
            <div className="rate-card bulk-orders">
              <h3>ಅಧಿಕ ಪ್ರಮಾಣದ ಆರ್ಡರ್</h3>
              <p className="rate best-rate">ಉತ್ತಮ ದರಗಳು</p>
              <ul className="features-list">
                <li><i className="fas fa-check"></i> ತೋಗರೆ ಮತ್ತು ಕಡಲೆ ಎರಡೂ</li>
                <li><i className="fas fa-check"></i> 10+ ಕ್ವಿಂಟಾಲ್</li>
                <li><i className="fas fa-check"></i> ಆದ್ಯತೆ ಸಂಸ್ಕರಣೆ</li>
                <li><i className="fas fa-check"></i> ಉಚಿತ ಸಾಗಣೆ</li>
                <li><i className="fas fa-check"></i> ಅದೇ ದಿನದ ಪಾವತಿ</li>
              </ul>
              <button className="contact-btn">ಈಗ ಸಂಪರ್ಕಿಸಿ</button>
            </div>
            <div className="rate-card chana-dal">
              <h3>ಕಡಲೆ (Bengal Gram)</h3>
              <p className="rate">ಮಾರುಕಟ್ಟೆ ದರ</p>
              <ul className="features-list">
                <li><i className="fas fa-check"></i> ಪ್ರೀಮಿಯಂ ಗುಣಮಟ್ಟ</li>
                <li><i className="fas fa-check"></i> ಕನಿಷ್ಠ 1 ಕ್ವಿಂಟಾಲ್</li>
                <li><i className="fas fa-check"></i> ಉಚಿತ ಗುಣಮಟ್ಟ ಪರೀಕ್ಷೆ</li>
              </ul>
              <button className="get-rate-btn">ಇಂದಿನ ದರ ಪಡೆಯಿರಿ</button>
            </div>
          </div>
        </div>
      </section>
    </div>
  );
};

export default Services; 